import React, { useEffect, useState } from "react";
import { Snackbar, Alert, Button } from "@mui/material";

const NotificationSnackbar = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");

  // Simulate receiving a new request
  const handleNewRequest = () => {
    setMessage("New request received!");
    setOpen(true);
  };

  // Handle close event
  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  useEffect(() => {
    handleNewRequest()
  },[])

  return (
    <div>
      

      {/* Snackbar Notification */}
      <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
        <Alert onClose={handleClose} severity="info" sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default NotificationSnackbar;
